import React from "react";

const Policies = () => {
  return (
    <div className="container mx-auto px-4 py-4">
      <h1 className="text-5xl justify-center flex mb-8 m-auto p-2">
        Our Policies
      </h1>
      <div className="bg-gradient-to-r from-primary via-white to-primary p-8 rounded-xl shadow-lg">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="mt-16 text-base leading-7 text-gray-800 space-y-4">
            <p style={{ fontFamily: "Trebuchet MS", fontWeight: "bold" }}>
              At SEPIYAR, customer satisfaction is paramount to us. Our policies
              are designed to ensure that every client receives the best
              possible experience. We deeply appreciate your business.
            </p>
            <p>
              All permanent cosmetic procedures involve multiple sessions. To
              achieve optimal results, we recommend clients return for one
              enhancement session approximately 5-10 weeks after their initial
              appointment. During this session, we assess color retention and
              make any necessary adjustments. This enhancement session is
              crucial and must be completed before finalizing your procedure.
              Healing outcomes vary for each client and depend on adherence to
              post-care instructions.
            </p>
            <h3 className="text-2xl font-semibold mb-2 text-gray-800">
              Payment Policy
            </h3>
            <p>
              SEPIYAR accepts major credit cards, debit cards, and cash. We do
              not accept checks or money orders. To secure your appointment, a
              100% non-refundable deposit is required through our online booking
              system. This deposit confirms your commitment and will be deducted
              from your total cost. The remaining balance will be charged on the
              day of your appointment. Please note that our booking system
              mandates a deposit to confirm all appointments.
            </p>
            <h3 className="text-2xl font-semibold mb-2 text-gray-800">
              Cancellation, Reschedule & No Show
            </h3>
            <p>
              Late cancellations, rescheduling, and "No Shows" create gaps in
              our schedule that cannot be filled without sufficient notice,
              which is why these policies are necessary.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Cancellation Policy
            </h4>
            <p>
              No cancellations or changes are permitted within 48 hours of your
              cosmetic tattooing appointment. For Brow Styling, Brow Lamination,
              and Lash Lamination appointments, you may reschedule or cancel up
              to 24 hours before your scheduled time. Failure to do so will
              result in forfeiting your deposit, requiring a new deposit for any
              rescheduling.
            </p>
            <p>
              Regarding Cosmetic Tattoo Appointments, please note that
              rescheduling or canceling requires a minimum 48-hour notice.
              Failure to provide adequate notice will result in the forfeiture
              of your booking deposit. Clients are responsible for reviewing our
              tattoo FAQs to ensure there are no contraindications that could
              prevent treatment on the scheduled day. Failure to do so may also
              result in forfeiture of your deposit.
            </p>
            <p>
              If you need to cancel or reschedule, please call us at{" "}
              <span className="text-pink-700 font-bold"> 0488103982 </span>
              or email us at{" "}
              <span className="text-pink-700 font-bold"> info@sepiyar.com </span>,
              ensuring to leave a voicemail if necessary.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Rescheduling Policy
            </h4>
            <p>
              If you need to reschedule your appointment, you are welcome to do
              so! The deposit from the missed appointment will be applied to a
              future booking, with the remaining balance due upon scheduling the
              new appointment. Please ensure to reschedule at least 48 hours
              before your original appointment time to use the deposit for your
              rescheduled appointment automatically.
            </p>
            <h4
              className="text-2xl font-semibold mb-2 text-gray-800"
              style={{ fontFamily: "Trebuchet MS" }}
            >
              No Show Policy
            </h4>
            <p>
              If a client fails to attend their scheduled appointment, whether
              it's for a new client session, enhancement session, or touch-up
              session, they will automatically lose their non-refundable
              deposit.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Lateness Policy
            </h4>
            <p>
              We understand that unexpected events can occur. However, to
              respect your artist and other scheduled clients, if you arrive 15
              minutes or later, your appointment and non-refundable deposit will
              be forfeited. Rescheduling will be necessary to avoid delays for
              subsequent clients.
            </p>
            <p>
              Please note that each procedure requires its allocated time to
              achieve optimal results; rushing is not possible. Depending on our
              schedule availability, we may consider accommodating late arrivals
              at our discretion.
            </p>
            <p>
              *We appreciate a call or email notifying us if you are running
              late.*
            </p>

            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Touch-Up Policy
            </h4>
            <p>
              <strong>NEW CLIENTS:</strong> Touch-ups are reserved exclusively
              for returning SEPIYAR clients. We do not provide touch-ups for
              work done by other artists at "touch-up" rates. If your initial
              service was performed by another artist elsewhere, you will be
              charged as a new client. Thank you for your understanding.
            </p>
            <p>
              <strong>EXISTING CLIENTS:</strong> Future touch-ups cannot be
              scheduled online to ensure accurate pricing based on your last
              appointment with us. Please contact us at <span className="text-pink-700 font-bold">0488103982</span> or email 
              <span className="text-pink-700 font-bold"> info@sepiyar.com</span> to book your touch-up appointment.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Existing Permanent Makeup Policy
            </h4>
            <p>
              We do not offer reduced-fee touch-ups for cosmetic tattoos done by
              other artists, as correcting previous work often requires
              additional effort and expertise.
            </p>
            <p>
              For new clients seeking correction of a cosmetic tattoo done
              elsewhere, a consultation is typically necessary to assess
              feasibility. Please email us at{" "}
              <span className="text-pink-700 font-bold"> info@sepiyar.com</span>{" "}
              with a clear, makeup-free photo in natural light of the treated
              area. This allows our cosmetic tattoo artist to evaluate and
              determine the appropriate correction method before scheduling an
              appointment.
            </p>
            <p>
              At SEPIYAR, correction work typically involves two sessions: an
              initial session followed by an enhancement session 5-10 weeks
              later. Each appointment lasts approximately 1-2 hours to ensure
              meticulous work. Your enhancement session will be scheduled on the
              day of your initial session to allow your skin adequate time to
              heal and regenerate fully. Additional sessions may be needed at
              touch-up rates.
            </p>
            <p>
              Please be aware that in certain cases, correction may not be
              advisable, and laser removal could be recommended as an
              alternative solution. We are here to assist and welcome you as a
              new client if we can be of service.
            </p>
            <h3 className="text-2xl font-semibold mb-2 text-gray-800">
              No Guest Policy
            </h3>
            <p>
              Guests are not permitted to accompany you into the studio unless
              prior arrangements have been made.
            </p>
            <p>
              We have a zero-tolerance policy regarding children. While we adore
              children, safety is our utmost priority. Therefore, we kindly
              request that you refrain from bringing your little ones to the
              studio. This policy ensures their safety and maintains the comfort
              of our clients.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Age Requirement Policy
            </h4>
            <p>
              Our studio maintains an adult-oriented atmosphere, and as such, we
              only accept appointments for clients who are 18 years of age or
              older.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Rates Policy
            </h4>
            <p>
              SEPIYAR reserves the right to adjust, discontinue, or revise
              service prices without prior notice to uphold the highest
              standards of service and quality. Rates may vary for travel, guest
              appearances, out-call services, or under special circumstances.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Eating or Drinking
            </h4>
            <p>
              Please ensure you drink plenty of water before and after your
              appointment. We kindly ask that you refrain from bringing outside
              food into the studio, and please note that alcoholic beverages are
              not permitted on our premises. Thank you for your understanding.
            </p>
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Photo/Video Release
            </h4>
            <p>
              SEPIYAR may utilize images or videos for website, social media,
              brochures, flyers, or other advertising deemed necessary. By
              signing the consent form, clients agree or disagree to release any
              claims regarding the use of their images for such purposes. For
              liability reasons, before and after photos are required for our
              records. If you do not consent, we will fully respect your
              decision and note it on your profile
            </p>
            <h3 className="text-2xl font-semibold mb-2 text-gray-800">
              Important Information Before Booking
            </h3>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Prerequisites:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                Please read the FAQ and Pre-Post Care information before
                booking.
              </li>
              <li>
                Complete the SEPIYAR medical consent form to confirm your
                suitability for the procedure.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Medical Requirements:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                If you have a serious medical condition, bring a doctor's note
                confirming you can proceed with the procedure.
              </li>
            </ul>

            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Patch Test:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                A patch test can be requested to check for allergic reactions
                during a consultation.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Scheduling:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                Do not book an appointment within a week of important events.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Appointment Confirmation:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                You will receive an email reminder/confirmation 48 hours before
                your scheduled appointment.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Results and Expectations:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                While we strive for the highest quality, we cannot guarantee
                perfect results for every client, especially those with
                problematic skin.
              </li>
              <li>
                Additional touch-ups may be necessary, and cosmetic products
                might still be required to achieve your desired look.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Alcohol/Drug Policy:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                Appointments will be canceled if you are suspected of being
                under the influence of alcohol or drugs.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Payment Policy:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                Advance payment may be required for clients with a history of
                no-shows or late cancellations.
              </li>
              <li>
                No refunds will be provided once the procedure is completed. It
                is your responsibility to care for your investment after the
                service.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Right to Refuse Service:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                We reserve the right to refuse any procedure deemed unsuitable
                or unsafe for the client.
              </li>
            </ul>
            <h4 className="text-xl font-semibold mb-2 text-gray-800">
              Communication:
            </h4>
            <ul className="list-disc list-inside mb-4">
              <li>
                If we are busy, please leave a voicemail, and we will return
                your call as soon as possible.
              </li>
            </ul>

            <p style={{ fontFamily: "Trebuchet MS", fontWeight: "bold" }}>
              Our policies are strictly enforced without exceptions. By booking
              your appointment with SEPIYAR, you confirm that you have read,
              understood, and agree to our Terms and Conditions.
            </p>
            <p style={{ fontFamily: "Trebuchet MS", fontWeight: "bold" }}>
              Copyright © 2024 SEPIYAR, All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;
